<template>
  <Toast/>
  <DialogConfirmation ref="dialogConfirmation"/>
  <div class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="categories"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          selectionMode="single"
          dataKey="cle"
          @row-select="onRowSelect"
          :paginator="true"
          :rows="10"
          sort-field="pays"
          :sortOrder="-1"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} villes"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="entite"
            header="Entité"
            :sortable="true"
        ></Column>
        <Column
            field= "genre"
            header="Genre"
            :sortable="true"
        ></Column>
        <Column
            field="nature"
            header="Nature"
            :sortable="true"
        ></Column>
        <Column
            field="type"
            header="Type"
            :sortable="true"
        ></Column>
        <Column
            field="description"
            header="Catégorie"
            :sortable="true"
        ></Column>
        <Column headerStyle="width: 8rem" :exportable="false">
          <template #body="slotProps">
            <Button
                icon="pi pi-trash"
                class="p-button-datatable p-button-rounded-sm"
                @click="confirmerSuppression(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import axios from "axios";
import DialogConfirmation from "@/components/Commun/DialogConfirmation.vue";

export default {
    components: {DialogConfirmation},
  props: ['categories', 'isRechercheDataLoading'],
  data() {
    return {
        categorieASupprimer: null,
    }
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
  },
  methods: {
    onRowSelect(event) {
      this.$store.commit('pilotage/CATEGORIE',event.data);
      this.$router.push({
        name: "modifierCategorie",
        params: {
            cle: event.data.cle,
            entite: event.data.entiteCle,
            genre: event.data.genreCle,
            nature: event.data.natureCle,
            type: event.data.typeCle
        }
      });
    },
    confirmerSuppression(lien) {
      this.categorieASupprimer = lien;
      this.$confirm.require({
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          message: "Voulez-vous supprimer cette catégorie?",
          accept: this.categorieSupprimer,
          reject: () => {
          },
      })
    },
    categorieSupprimer() {
      this.$store.dispatch('pilotage/supprimerTableValeurAction', {
          tableValeur: this.categorieASupprimer
      });
    },
  },
}
</script>
